import { lazy } from "react";

// Módulo OCULTO (2026-08-10): no hay contrato con transportation por ahora y
// no se está trabajando en él. Siguiendo la convención (el módulo resuelve su
// propio flag), con el flag en false se exporta [] y la ruta no se monta; el
// código queda intacto por si se retoma.
const TRANSPORTATION_ENABLED = false;

const TransportationPage = lazy(() => import("./pages/TransportationPage"));

export const transportationRoutes = TRANSPORTATION_ENABLED
  ? [{ path: "/transportation", element: <TransportationPage /> }]
  : [];
